import React from "react";

import { Button } from "~/components/button";

import { CloseDrawerButton, DrawerTitle, ExplorationDrawer } from "../react/drawer/ExplorationDrawer";

import { DrawerContent } from "./_drawer-content";
import type { DrawerState } from "./_drawer-state";
import { FORM_ID } from "./_form-id";

export interface DrawerProps {
	when: undefined | DrawerState;
}

export const Drawer: React.FC<DrawerProps> = ({ when }) => (
	<ExplorationDrawer
		footer={<Footer />}
		headerTitle={<DrawerTitle title="Edit Dashboard Variables" />}
		id={when?.id}
		layout="full"
		when={when}
	>
		{(state, close, preservedState) => (
			<DrawerContent
				{...state}
				onSave={(output) => {
					state.onSave(output);
					close();
				}}
				variables={preservedState?.variables ?? state.variables}
			/>
		)}
	</ExplorationDrawer>
);

const Footer: React.FC = () => (
	<>
		<CloseDrawerButton />
		<Button className="uppercase" form={FORM_ID} type="submit" variant="primary">
			Update variables
		</Button>
	</>
);
